import { Chip, Grid } from "@mui/material";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import React from "react";

function calculateValue(value) {
  return value;
}

const SliderNotation = ({
  val,
  step,
  min_val,
  max_val,
  on_leave,
  disabled = false,
}) => {
  const [value, setValue] = React.useState(val || 0);
  const [max_value, setMaxValue] = React.useState(max_val || 10);
  const [min_value, setMinValue] = React.useState(min_val || 0);
  const [step_value, setStepValue] = React.useState(step || 1);

  function valueScoreFormat(value) {
    return `${value} / ${max_value}`;
  }

  function valueLabelFormat(value) {
    const rating = findOutEvaluationParticulier(value, max_value);
    return `${valueScoreFormat(value)}${rating ? ` - ${rating}` : ""}`;
  }

  const getObservationStyle = (observation) => {
    const normalizedObservation = String(observation || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (normalizedObservation.includes("faible")) {
      return { color: "#b42318", background: "#fff5f4", border: "#fecdca" };
    }
    if (normalizedObservation.includes("non satisfaisant")) {
      return { color: "#b54708", background: "#fffaeb", border: "#fedf89" };
    }
    if (normalizedObservation.includes("satisfaisant")) {
      return { color: "#067647", background: "#f3fcf7", border: "#abefc6" };
    }
    if (normalizedObservation.includes("superieur")) {
      return { color: "#175cd3", background: "#f5f8ff", border: "#b2ccff" };
    }
    if (normalizedObservation.includes("exceptionnel")) {
      return { color: "#6941c6", background: "#faf8ff", border: "#d9d6fe" };
    }
    return { color: "#475467", background: "#f8fafc", border: "#d0d5dd" };
  };

  const getTicksMarks = (min, max, pas) => {
    let columns = [];
    for (let i = min - 1; i < max; i += pas) {
      columns.push({
        value: i + 1,
        label: i + 1,
      });
    }
    return columns;
  };

  const handleChange = (event, newValue) => {
    if (typeof newValue === "number") {
      setValue(newValue);
    }
  };

  const handleMouseOnLeave = (evt, newVal) => {
    if (on_leave) {
      on_leave(newVal);
    }
  };

  const findOutEvaluationParticulier = (note_total, note_max_total) => {
    if (note_max_total <= 0) return "";
    const niveau = Math.ceil((Number(note_total) / Number(note_max_total)) * 5);

    if (niveau <= 0) return "";
    if (niveau === 1) {
      return "Faible";
    } else if (niveau === 2) {
      return "Non satisfaisant";
    } else if (niveau === 3) {
      return "Satisfaisant";
    } else if (niveau === 4) {
      return "Supérieur";
    } else {
      return "Exceptionnel";
    }
  };

  const observation = findOutEvaluationParticulier(value, max_value);
  const observationStyle = getObservationStyle(observation);

  return (
    <Grid container justifyContent="center" width={"100%"}>
      <Grid item xs={11} md={6} /*  width={"50vw"} */>
        <Grid
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          gap={0.75}
          mb={1}
        >
          <Typography id="non-linear-slider" variant="body2">
            Note donnée: {valueScoreFormat(value)}
          </Typography>
          <Chip
            size="small"
            label={observation || "Non evalue"}
            sx={{
              height: 24,
              color: observationStyle.color,
              bgcolor: observationStyle.background,
              border: `1px solid ${observationStyle.border}`,
              fontWeight: 600,
            }}
          />
        </Grid>
        <Slider
          value={value}
          disabled={disabled}
          min={min_value}
          step={step_value}
          marks={getTicksMarks(min_value, max_value, step_value)}
          max={max_value}
          scale={calculateValue}
          getAriaValueText={valueLabelFormat}
          valueLabelFormat={valueLabelFormat}
          onChange={handleChange}
          onMouseLeave={(e) => handleMouseOnLeave(e, value)}
          valueLabelDisplay="auto"
          aria-labelledby="non-linear-slider"
        />
      </Grid>
    </Grid>
  );
};

export default SliderNotation;
